import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ListWrapperResponse } from '@ip-only/front-end-library';

import { FeatureCollection } from 'geojson';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import {
  DistributionPointProperties,
  InfoPointProperties,
  InformationPointResponse,
  PermitAreaResponse,
  SpanProperties,
  Version,
} from '../../span-progress-entities';

export interface LandAgreementStatus {
  name: string;
  status: 'Klart' | 'Ej klart';
}

export const spanProgressBaseUrl = `${environment.spanProgressApiUrl}`;
export const spanProgressBaseUrlV2 = `${environment.spanProgressApiUrlV2}`;
const mapUrl = `${spanProgressBaseUrl}/field-maps`;

@Injectable({ providedIn: 'root' })
export class MapApiService {
  constructor(private readonly http: HttpClient) {}

  getMbTiles(ifs: string) {
    return this.http
      .get(`${mapUrl}/${ifs}`, {
        responseType: 'arraybuffer',
        observe: 'response',
      })
      .pipe(
        map((response: HttpResponse<ArrayBuffer>) => {
          const header = response.headers.get('Content-Disposition');
          const file = response.body;
          if (!file || !header) {
            throw new Error('Invalid file response returned');
          }
          const fileName = header.substring(
            header.indexOf('"') + 1,
            header.lastIndexOf('"'),
          );
          return {
            fileName,
            file,
          };
        }),
      );
  }

  checkForNewMap(fileName: string) {
    return this.http
      .post<{ status: boolean }>(`${mapUrl}/check-file`, {
        fileName,
      })
      .pipe(
        map((response) => response.status),
        catchError(() => {
          return of(false);
        }),
      );
  }

  getSpanGeoJson(ifs: string) {
    return this.http.get<FeatureCollection<GeoJSON.LineString, SpanProperties>>(
      `${spanProgressBaseUrl}/span/${ifs}`,
    );
  }

  getLandAgreementGeoJson(ifs: string) {
    return this.http.get<FeatureCollection<GeoJSON.Polygon>>(
      `${spanProgressBaseUrl}/land-agreements/${ifs}`,
    );
  }

  getDistributionPointGeoJson(ifs: string) {
    return this.http.get<
      FeatureCollection<GeoJSON.Point, DistributionPointProperties>
    >(`${spanProgressBaseUrlV2}/distribution-points/${ifs}`);
  }

  getInformationPointGeoJson(ifs: string) {
    return this.http.get<FeatureCollection<GeoJSON.Point, InfoPointProperties>>(
      `${spanProgressBaseUrl}/information-points/${ifs}`,
    );
  }

  getInformationPoints(ifs: string) {
    return this.http
      .get<
        ListWrapperResponse<InformationPointResponse>
      >(`${spanProgressBaseUrl}/information-points?projectId=${ifs}`)
      .pipe(map((response) => response.items));
  }

  getVersion(ifs: string) {
    return this.http.get<Version>(
      `${spanProgressBaseUrl}/construction-documents/latest-version/${ifs}`,
    );
  }

  getPermitAreaGeoJson(ifs: string) {
    return this.http.get<PermitAreaResponse[]>(
      `${spanProgressBaseUrl}/permits?projectId=${ifs}`,
    );
  }
}
